import store from '@/store';
import { pinMarker } from '@/common/utils/Util';

export const BUSINESS_BLACK_LIST = [
  '/business/register/step1',
  '/business/register/step2',
  '/business/register/step3',
  '/business/update/step2',
  '/business/update/step3'
];

export const BUSINESS_REGISTER = ['/business/register/step1', '/business/register/step2', '/business/register/step3'];
export const BUSINESS_UPDATE = ['/business/update/step2', '/business/update/step3'];

// 경로 url 패턴을 생성하는 함수
const asPattern = (str = '') => {
  const exp = str
    .split('/')
    .filter(elem => !!elem)
    .reduce((prev, next) => {
      if (prev) return prev + `(\\/${next})`;
      else return prev + `(\\/${next})`;
    }, '');

  return new RegExp(`${exp}(\/.*)?`, 'gsi');
};
const generatePattern = (...path) => {
  if (Array.isArray(path)) return path.map(pathPiece => asPattern(pathPiece));
  else return asPattern(path);
};

const isBlocked = (path, blackList = []) => {
  return generatePattern(...blackList).filter(elem => elem.test(path)).length > 0;
};

const isPassed = (path, whiteList = []) => {
  return whiteList.includes(path);
};

const isBusinessBlocked = (toPath, fromPath) => {
  return generatePattern(...BUSINESS_BLACK_LIST).filter(elem => elem.test(toPath) && fromPath === '/').length > 0;
};

const isBusinessRegister = (toPath, fromPath) => {

  if (toPath === '/business/register/step1') {
    return false; // 최초 진입 허용
  }

  const keywords = ['register'];
  const isToBlackListed = BUSINESS_REGISTER.some(black => toPath.startsWith(black));
  store.commit('business/registerPin');
  if (isToBlackListed) {
    // fromPath에 키워드 포함 여부 확인
    const fromHasKeyword = keywords.some(keyword => fromPath.includes(keyword));
    if (!fromHasKeyword) {
      const data = store.getters['business/getDetail'];

      store.commit('business/searchText', data.name);
      if (data.latitude && data.longitude) {
        store.commit('business/coordinate', { latitude: data.latitude, longitude: data.longitude });
      }
      store.commit('business/registerPin', data);

      pinMarker(data.latitude, data.longitude);
    }
    return !fromHasKeyword;
  }
  return false;
};

const isBusinessUpdate = (toPath, fromPath) => {
  const keywords = ['update'];
  const isToBlackListed = BUSINESS_UPDATE.some(black => toPath.startsWith(black));
  if (isToBlackListed) {
    const fromHasKeyword = keywords.some(keyword => fromPath.includes(keyword));
    return !fromHasKeyword;
  }
  return false;
};

export const immigration = (to, from, next, router, blackList, whiteList) => {
  const { path } = to;
  if (isBusinessBlocked(path, from.path)) return next('/business');
  if (isBusinessRegister(path, from.path)) return next('/business');
  if (isBusinessUpdate(path, from.path)) return next('/business');
  if (store.getters['user/getAccessToken']) return true;
  if (isPassed(path, whiteList)) return true;

  return !isBlocked(path, blackList);
};

// const routerGo = (router, next, path) => {
//   next(false);
//   setTimeout(() => {
//     window.location.replace(path);
//   }, 0);
// };
